import React, { useState, Component } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { CheckCircle2, ChevronDown, Globe2, Award } from 'lucide-react';
type IconType = ComponentType<{
  size?: number;
  className?: string;
  strokeWidth?: number;
}>;
interface Opcion {
  icon: IconType;
  optionTitle: string;
  optionSubtitle: string;
  nombre: string;
  etiqueta: string;
  ahorro: string;
  precioAnterior: string;
  precioPromo: string;
  beneficios: string[];
  ctaHref: string;
}
const opciones: Opcion[] = [{
  icon: Globe2,
  optionTitle: 'Completar mis aguas abiertas durante un viaje',
  optionSubtitle: 'Entrenamiento en Buenos Aires y certificación en cualquier centro PADI del mundo.',
  nombre: 'Open Water Diver + Referral PADI',
  etiqueta: 'Certificá en cualquier centro PADI del mundo',
  ahorro: '$158.000',
  precioAnterior: '$790.000',
  precioPromo: '$632.000',
  beneficios: ['Material digital oficial PADI', 'Equipo completo incluido', '5 entrenamientos en piscina', 'Teoría y práctica supervisada', 'Referral PADI oficial', 'Certificación en cualquier centro PADI del mundo'],
  ctaHref: 'https://checkout.librofy.online/cart/53360052273515:1'
}, {
  icon: Award,
  optionTitle: 'Completar toda mi certificación en Buenos Aires',
  optionSubtitle: 'Curso completo incluyendo las inmersiones de certificación.',
  nombre: 'Open Water Diver Completo',
  etiqueta: 'Completá toda tu certificación en Buenos Aires',
  ahorro: '$158.000',
  precioAnterior: '$1.580.000',
  precioPromo: '$1.422.000',
  beneficios: ['Material digital oficial PADI', 'Equipo completo incluido', '5 entrenamientos en piscina', 'Teoría y práctica supervisada', '4 inmersiones de certificación en aguas abiertas', 'Certificación PADI completa en Buenos Aires'],
  ctaHref: 'https://checkout.librofy.online/cart/53360065184107:1'
}];
export function Planes() {
  const [selected, setSelected] = useState<number | null>(0);
  const [detailsOpen, setDetailsOpen] = useState(false);
  const select = (index: number) => {
    setDetailsOpen(false);
    setSelected(prev => prev === index ? null : index);
  };
  return <section id="planes" className="py-24 px-6 bg-brand-dark relative scroll-mt-20" data-id="element-230">
      <div className="max-w-2xl mx-auto" data-id="element-231">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="text-center mb-12" data-id="element-232">
          <h3 className="text-white font-heading font-bold text-3xl sm:text-4xl md:text-5xl uppercase tracking-tight mb-5 leading-tight" data-id="element-233">
            La misma certificación.
            <br data-id="element-234" />
            <span className="text-brand-primary" data-id="element-235">
              Dos formas de completarla.
            </span>
          </h3>
          <p className="text-white/85 text-lg sm:text-xl font-light" data-id="element-236">
            Elegí dónde realizar tus inmersiones en aguas abiertas: en Buenos
            Aires o durante tu próximo viaje.
          </p>
        </motion.div>

        <div className="space-y-4" data-id="element-237">
          {opciones.map((op, index) => {
          const isSelected = selected === index;
          return <div key={index} className={`rounded-3xl border overflow-hidden transition-colors duration-300 ${isSelected ? 'border-brand-primary bg-brand-background shadow-[0_16px_50px_-20px_rgba(0,184,217,0.4)]' : 'border-brand-primary/20 bg-brand-background/60'}`} data-id="element-238">
                {/* Selector header */}
                <button onClick={() => select(index)} aria-expanded={isSelected} className="w-full flex items-start gap-4 p-5 sm:p-6 text-left focus:outline-none focus-visible:ring-2 focus-visible:ring-brand-primary/60 rounded-3xl" data-id="element-239">
                  <span className="w-10 h-10 rounded-full bg-brand-primary/10 flex items-center justify-center text-brand-primary shrink-0 mt-0.5" data-id="element-240">
                    <op.icon size={20} strokeWidth={1.5} data-id="element-241" />
                  </span>
                  <span className="flex-grow" data-id="element-242">
                    <span className="block text-white font-bold text-base sm:text-lg leading-snug" data-id="element-243">
                      {op.optionTitle}
                    </span>
                    <span className="block text-white/60 text-sm mt-1 leading-snug" data-id="element-244">
                      {op.optionSubtitle}
                    </span>
                    <span className="block text-brand-primary font-bold text-sm mt-2" data-id="element-245">
                      Desde {op.precioPromo}
                    </span>
                  </span>
                  <ChevronDown size={22} className={`text-brand-primary shrink-0 mt-1 transition-transform duration-300 ${isSelected ? 'rotate-180' : ''}`} data-id="element-246" />
                </button>

                {/* Expanded plan details */}
                <AnimatePresence initial={false} data-id="element-247">
                  {isSelected && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.35,
                ease: 'easeInOut'
              }} className="overflow-hidden" data-id="element-248">
                      <div className="px-5 sm:px-6 pb-6 pt-1" data-id="element-249">
                        <div className="border-t border-brand-primary/15 pt-5" data-id="element-250">
                          <h4 className="text-white font-heading font-bold text-lg sm:text-xl uppercase tracking-tight mb-3" data-id="element-251">
                            {op.nombre}
                          </h4>

                          <span className="inline-flex items-center gap-1.5 rounded-full border border-brand-primary/30 bg-brand-primary/10 text-brand-details text-xs sm:text-sm font-medium px-3 py-1.5 mb-5 self-start" data-id="element-252">
                            <op.icon size={14} className="text-brand-primary" strokeWidth={2} data-id="element-253" />
                            {op.etiqueta}
                          </span>

                          {/* Price */}
                          <div className="flex flex-col mb-6" data-id="element-254">
                            <span className="inline-flex self-start items-center rounded-full border border-brand-primary/40 bg-brand-primary/10 text-brand-primary text-xs font-bold tracking-widest uppercase px-3 py-1 mb-2" data-id="element-255">
                              Ahorrás {op.ahorro}
                            </span>
                            <span className="text-white/40 line-through text-base mb-0.5" data-id="element-256">
                              {op.precioAnterior}
                            </span>
                            <span className="text-white font-bold text-5xl sm:text-6xl tracking-tight leading-none" data-id="element-257">
                              {op.precioPromo}
                            </span>
                          </div>

                          {/* Reservation */}
                          <div className="rounded-2xl border border-brand-primary/30 bg-brand-primary/5 p-5 mb-6" data-id="element-258">
                            <span className="block text-brand-details text-xs font-bold tracking-widest uppercase mb-2" data-id="element-259">
                              Reservá tu vacante
                            </span>
                            <div className="flex items-baseline gap-2 mb-3" data-id="element-260">
                              <span className="text-white/70 text-sm font-medium" data-id="element-261">
                                Seña
                              </span>
                              <span className="text-brand-primary font-heading font-black text-3xl sm:text-4xl tracking-tight" data-id="element-262">
                                $100.000
                              </span>
                            </div>
                            <p className="text-white/70 text-sm leading-relaxed" data-id="element-263">
                              Tu reserva asegura tu lugar dentro del curso y
                              congela el precio promocional vigente.
                            </p>
                            <p className="text-white/50 text-xs mt-2" data-id="element-264">
                              El importe de la reserva se descuenta del valor
                              total del curso.
                            </p>
                          </div>

                          {/* Inner accordion */}
                          <div className="mb-6 border-t border-brand-primary/15 pt-3" data-id="element-265">
                            <button onClick={() => setDetailsOpen(o => !o)} aria-expanded={detailsOpen} className="w-full flex items-center justify-between text-left text-brand-primary font-semibold text-sm sm:text-base focus:outline-none focus-visible:ring-2 focus-visible:ring-brand-primary/60 rounded-lg py-1" data-id="element-266">
                              <span data-id="element-267">¿Qué incluye este plan?</span>
                              <ChevronDown size={20} className={`transition-transform duration-300 ${detailsOpen ? 'rotate-180' : ''}`} data-id="element-268" />
                            </button>
                            <AnimatePresence initial={false} data-id="element-269">
                              {detailsOpen && <motion.div initial={{
                          height: 0,
                          opacity: 0
                        }} animate={{
                          height: 'auto',
                          opacity: 1
                        }} exit={{
                          height: 0,
                          opacity: 0
                        }} transition={{
                          duration: 0.3,
                          ease: 'easeInOut'
                        }} className="overflow-hidden" data-id="element-270">
                                  <ul className="space-y-3 pt-4" data-id="element-271">
                                    {op.beneficios.map((item, i) => <li key={i} className="flex items-start gap-3 text-white/90 text-sm sm:text-base" data-id="element-272">
                                        <CheckCircle2 size={18} className="text-brand-primary shrink-0 mt-0.5" data-id="element-273" />
                                        <span data-id="element-274">{item}</span>
                                      </li>)}
                                  </ul>
                                </motion.div>}
                            </AnimatePresence>
                          </div>

                          <a href={op.ctaHref} target="_blank" rel="noopener noreferrer" className="block text-center w-full bg-gradient-to-r from-[#00B8D9] to-[#4FC3F7] text-[#031D33] font-bold uppercase tracking-widest py-4 px-6 rounded-full transition-all duration-300 transform hover:scale-[1.02] active:scale-[0.98] shadow-[0_10px_30px_-5px_rgba(0,184,217,0.4)]" data-id="element-275">
                            Reservar mi lugar
                          </a>
                        </div>
                      </div>
                    </motion.div>}
                </AnimatePresence>
              </div>;
        })}
        </div>
      </div>
    </section>;
}